import { render, staticRenderFns } from "./wtRebrand.component.vue?vue&type=template&id=62aac461&"
import script from "./wtRebrand.component.vue?vue&type=script&lang=js&"
export * from "./wtRebrand.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports